import { useIsFocused } from '@react-navigation/native';
import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { NavigationStacks, Screens, Stacks } from 'components/Navigation/types';
import { ImageBackground } from 'expo-image';
import { useSelector } from 'hooks/useSelector';
import * as React from 'react';
import { View } from 'react-native';
import { useDispatch } from 'react-redux';
import { LocalAssets } from 'screens/AssetsScreen/LocalAssets/LocalAssets';
import { NoLocalAssets } from 'screens/AssetsScreen/LocalAssets/NoLocalAssets';
import { doShowAppBackgroundImage } from 'store/actions';
import { selectAppType, selectHasSidebarNavigation } from 'store/app/selectors';
import { selectAssetsTotal } from 'store/assets/selectors';

// type Props = CompositeScreenProps<
//   DrawerScreenProps<DrawerParamList, 'MyScreen'>,
//   NativeStackScreenProps<
//     NavigationStacks[Stacks.OFFLINE],
//     Screens.OFFLINE_ASSET
//   >
// >;

type Props = NativeStackScreenProps<
  NavigationStacks[Stacks.OFFLINE],
  Screens.OFFLINE_ASSETS
>;

const AppBackdropImage = require('assets/backdrop.jpg');

export const AssetsScreen: React.FC<Props> = ({ navigation, route }) => {
  const dispatch = useDispatch();
  const inPages = route.params.inPages;
  const appType = useSelector(selectAppType);
  const hasSidebarNavigation = useSelector(selectHasSidebarNavigation);
  const totalAssets = useSelector(selectAssetsTotal);
  const isFocused = useIsFocused();

  React.useEffect(() => {
    dispatch(
      doShowAppBackgroundImage(
        totalAssets === 0 && isFocused && appType !== 'mobile',
      ),
    );
  }, [dispatch, isFocused, appType, totalAssets]);

  return totalAssets === 0 ? (
    <>
      {!hasSidebarNavigation && (
        <View
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 0,
            backgroundColor: 'white',
          }}
        >
          <ImageBackground
            contentFit="cover"
            contentPosition="center"
            style={{
              opacity: 0.2,
              flex: 1,
            }}
            source={AppBackdropImage}
          />
        </View>
      )}
      <NoLocalAssets inPages={inPages} />
    </>
  ) : (
    <LocalAssets navigation={navigation} inPages={inPages} />
  );
};
